// --- Dependencies -------------------------------------------------------------------------------
import { create } from "zustand";
import { persist } from "zustand/middleware";
// --- Our Modules --------------------------------------------------------------------------------
import type { TyRole } from "@/types";
// --- Logic --------------------------------------------------------------------------------------
/** The active organization. It rides every `/clients/*` request as `x-organization-id`. */
type TyOrganizationStore = {
    organizationId: string | null;
    role: TyRole | null;
    setOrganization: (organizationId: string, role: TyRole) => void;
    clearOrganization: () => void;
};

const useOrganization = create<TyOrganizationStore>()(
    persist(
        (set) => ({
            organizationId: null,
            role: null,
            setOrganization: (organizationId, role) => set({ organizationId, role }),
            clearOrganization: () => set({ organizationId: null, role: null }),
        }),
        { name: "organization" }
    )
);

export default useOrganization;
